






























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import TextArea from '@/components/common/inputs/TextArea.vue';
import RichTextArea from '@/components/common/inputs/RichTextArea.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import FormSection from '@/components/details/FormSection.vue';
import Well from '@/components/common/Well.vue';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import WellItem from '@/components/common/WellItem.vue';
import { ITSystem } from '@/store/modules/commonInterfaces';
import { HTTP } from '@/services/http-service';
import { Phase, PhaseKeys } from '@/models/phase';
import { ProcessModule, ProcessState } from '@/store/modules/process';
import Process from '@/store/modules/process';
import { CommonModule } from '@/store/modules/common';
import { ErrorModule } from '@/store/modules/error';
import { RootState } from '@/store';

@Component({
  components: {
    TextArea,
    RichTextArea,
    SelectionField,
    Well,
    FormSection,
    InfoTooltip,
    WellItem
  }
})
export default class ChallengesForm extends Vue {
  twoColumnBreakpoint = 1600;
  PhaseKeys = PhaseKeys;

  get state() {
    return ProcessModule;
  }

  get itSystems() {
    return CommonModule.itSystems;
  }

  get shouldBeOpen(): boolean {
    const href = window.location.href;
    const url = new URL(href);
    const params = url.searchParams;
    let search = null;
    for (const [key, value] of params) {
      if (key === 'search') {
        search = value;
        break;
      }
    }

    if (search != null) {
      const searchLowerCase = search.toLowerCase();
      if (this.state.longDescription?.toLocaleLowerCase()?.includes(searchLowerCase)) {
        return true;
      } else if (this.state.solutionRequests?.toLocaleLowerCase().includes(searchLowerCase)) {
        return true;
      } else if (this.state.processChallenges?.toLocaleLowerCase().includes(searchLowerCase)) {
        return true;
      }
    }

    return false;
  }

  minPhase(phase: Phase) {
    return ProcessModule.minPhase(phase);
  }

  update(state: Partial<ProcessState>) {
    ProcessModule.update(state);
  }

  assign(state: Partial<ProcessState>) {
    ProcessModule.assign(state);
  }

  isInErrors(name: string) {
    return ErrorModule.errorInField(ErrorModule.challenges, name);
  }
}
